export default __webpack_public_path__ + "static/media/FAIRLogo2020-white.ca634593.svg";